import { Spin } from 'antd'
import Loader from 'components/ui/Loader'
import { getArticlesWithPagination_getArticlesWithPagination_items } from 'graphql/query/__generated__/getArticlesWithPagination'

import KnowledgeBaseCard from '../../Cards/KnowledgeBaseCard'
import { EmptyContainer, EmptyText } from '../../Home/styled'
import { LoaderWrapper, Wrapper } from './styled'

type Props = {
  items?: getArticlesWithPagination_getArticlesWithPagination_items[]
  onFetchMore?: () => void
  next?: boolean
  loading: boolean
  loadingNext: boolean
}

function KnowledgeBaseList({ items, onFetchMore, next, loading, loadingNext }: Props) {
  if (loading) return <Loader noHeight />

  const isItems = !!items?.length
  return (
    <>
      <Wrapper
        dataLength={items?.length || 0}
        next={onFetchMore}
        hasMore={next}
        loader={null}
        grid={isItems}
        scrollableTarget="scrollable-wrapper"
      >
        {!isItems ? (
          <EmptyContainer>
            <EmptyText>No knowledge base</EmptyText>
          </EmptyContainer>
        ) : (
          items?.map((el) => <KnowledgeBaseCard key={el.articleId} {...el} />)
        )}
        <LoaderWrapper>
          <Spin spinning={loadingNext} />
        </LoaderWrapper>
      </Wrapper>
    </>
  )
}

export default KnowledgeBaseList
